import clsx from 'clsx';
import { ReactComponent as ErrorIcon } from 'components/Icon/lib/fieldError.svg';
import styles from './FieldError.module.scss';
import React from 'react';

type FieldErrorProps = {
  id: string; // The id is required because it needs to be applied to the 'aria-describedby' of the parent input
  className?: string;
  'data-testid'?: string;
}

export const FieldError: React.FC<FieldErrorProps> = ({ children, className, id, 'data-testid': testId }) => (
  <div role="alert" id={id} className={clsx(styles.errorText, className)} data-testid={testId}>
    {children && (
      <>
        <ErrorIcon role="presentation" />
        <div>{children}</div>
      </>
    )}
  </div>
);
